export const mdComponents = {
  h2: ({ node, ...props }) => (
    <h2 className="font-display uppercase tracking-[0.08em] text-lg sm:text-xl mt-8 mb-3 first:mt-0" style={{ color: "#C5A059" }} {...props} />
  ),
  p: ({ node, ...props }) => <p className="font-body text-[15px] leading-relaxed mb-3" style={{ color: "#E5E5EA" }} {...props} />,
  strong: ({ node, ...props }) => <strong style={{ color: "#F4EAD4", fontWeight: 600 }} {...props} />,
  ul: ({ node, ...props }) => <ul className="list-disc pl-5 space-y-1.5 mb-3 font-body text-[15px]" style={{ color: "#E5E5EA" }} {...props} />,
  li: ({ node, ...props }) => <li className="leading-relaxed" {...props} />,
  em: ({ node, ...props }) => <em style={{ color: "#A2A2A6" }} {...props} />,
  hr: () => <hr className="my-6 border-0 h-px" style={{ backgroundColor: "rgba(230,198,135,0.25)" }} />,
};
